<template>
    <div class="card" v-bind:class="{ fullscreen_expand: isFullscreen }">
        <!--Header-->
        <div class="card-header">
            <div class="card-header">
                <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"
                        @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                <div class="heading-elements" v-bind:class="{
                    visible: getSubMenuShowHideFw(),
                    '': !getSubMenuShowHideFw(),
                }">
                    <ul class="list-inline mb-0">
                        <li>
                            <a @click="expandFullscreenFw()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen">
                                <i class="ft-maximize"></i></a>
                        </li>
                        <li>
                            <a @click="expandFullscreenFw()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen">
                                <i class="ft-minimize"></i></a>
                        </li>
                        <li>
                            <a @click="showFilters = !showFilters" v-b-tooltip.hover.left="'Filtros'">
                                <i class="fa fa-filter"></i></a>
                        </li>
                    </ul>
                </div>
            </div>
            <div v-if="showFilters" @keyup.enter="doFilter">
                <b-row class="mb-1">
                    <b-col md="10"></b-col>
                    <b-col md="2" cols="12" class=" d-flex justify-content-end">
                        <b-btn @click="onResolveEvent()" class="secondary" :disabled="lossDisabled"
                            :class="{ 'w-100': deviceSize == DeviceSizeEnum.XS }">Apontar resolução</b-btn>
                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-1">
                    <b-col md="2">
                      <b-input v-model="invoiceNFeInput" id="invoiceNFe" placeholder="N Fiscal NFe"
                            autofocus type="text" ref="invoiceNFeInput">
                        </b-input>
                    </b-col>
                    <b-col md="1">
                      <b-input v-model="batchIdInput" id="batch" placeholder="Lote" type="text" ref="batch">
                        </b-input>
                    </b-col>
                    <b-col md="1">
                      <b-input v-model="cargoInput" id="cargo" placeholder="Carga" type="text" ref="cargo">
                        </b-input>
                    </b-col>
                    <b-col md="2">
                      <b-form-datepicker locale="pt-br" reset-button
                            placeholder="Data de Ocorrencia Inicial" v-model="initialEventDateInput"
                            class="form-control"
                            :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }">
                        </b-form-datepicker>
                    </b-col>
                    <b-col md="2">
                      <b-form-datepicker locale="pt-br" reset-button placeholder="Data de Ocorrencia Final"
                            v-model="finalEventDateInput" class="form-control"
                            :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }">
                        </b-form-datepicker>
                    </b-col>
                    <b-col md="2">
                      <b-input v-model="mdfeInput" id="mdfeId" maxlength="44" placeholder="MDFe" type="text"
                            ref="mdfeInput">
                        </b-input>
                    </b-col>
                    <b-col md="2">
                      <b-input v-model="redispatchNameInput" id="redispatchName"
                            placeholder="Razão Social Redespacho" type="text" ref="redispatchNameInput">
                        </b-input>
                    </b-col>
                    <b-col md="2">
                      <b-input v-model="redispatchIdInput" id="redispatchId" placeholder="CNPJ Redespacho"
                            type="text" ref="redispatchIdInput">
                        </b-input>
                    </b-col>
                    <b-col md="2">
                      <b-form-datepicker locale="pt-br" reset-button
                            placeholder="Data de Emissão Doc Inicial" v-model="initialInvoiceDateInput"
                            class="form-control"
                            :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }">
                        </b-form-datepicker>
                    </b-col>
                    <b-col md="2">
                      <b-form-datepicker locale="pt-br" reset-button
                            placeholder="Data de Emissão Doc Final" v-model="finalInvoiceDateInput" class="form-control"
                            :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }">
                        </b-form-datepicker>
                    </b-col>
                    <b-col md="2">
                      <b-input v-model="senderNameInput" id="senderName"
                            placeholder="Razão Social Remetente" type="text" ref="senderNameInput">
                        </b-input>
                    </b-col>
                    <b-col md="2">
                      <b-input v-model="senderCnpjInput" id="senderId" placeholder="CNPJ Remetente"
                            type="text" ref="senderCnpjInput">
                        </b-input>
                    </b-col>
                    <b-col md="2">
                      <multiselect v-model="area.input" track-by="area_id" label="descr"
                                   :placeholder="area.placeholder" tag-placeholder="" select-label=""
                                   :options="area.options"
                                   :clear-on-select="false" :hide-selected="true" :disabled="area.disabled"></multiselect>
                    </b-col>
                    <b-col md="2">
                      <b-form-datepicker locale="pt-br" reset-button placeholder="Data Emissão NF Inicial"
                            v-model="initialEmissionDateInput" class="form-control"
                            :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }">
                        </b-form-datepicker>
                    </b-col>
                    <b-col md="2">
                      <b-form-datepicker locale="pt-br" reset-button placeholder="Data Emissão NF Final"
                            v-model="finalEmissionDateInput" class="form-control"
                            :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }">
                        </b-form-datepicker>
                    </b-col>
                    <b-col md="2">
                      <b-form-datepicker locale="pt-br" reset-button placeholder="Data Previsão Inicial"
                            v-model="initialForecastDateInput" class="form-control"
                            :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }">
                        </b-form-datepicker>
                    </b-col>
                    <b-col md="2">
                      <b-form-datepicker locale="pt-br" reset-button placeholder="Data Previsão Final"
                            v-model="finalForecastDateInput" class="form-control"
                            :date-format-options="{ day: 'numeric', month: 'numeric', year: 'numeric' }">
                        </b-form-datepicker>
                    </b-col>
                    <b-col md="4">
                      <b-input v-model="barcodeInput" id="barcode" maxlength="35"
                            placeholder="Código de Barras" type="text" ref="barcode">
                        </b-input>
                    </b-col>
                    <b-col md="3">
                        <multiselect v-model="occurance.input" track-by="parocorren_id" label="descr"
                            :placeholder="occurance.placeholder" tag-placeholder="" select-label=""
                            :options="occurance.options" :clear-on-select="false" :hide-selected="true"
                            :disabled="occurance.disabled">
                        </multiselect>
                    </b-col>
                    <b-col sm="6" md="1">
                      <b-input v-model="volumeInput" id="volume" placeholder="Volume" type="text"
                            ref="volume">
                        </b-input>
                    </b-col>
                    <b-col md="3">
                        <multiselect v-model="volumeStatus.input" track-by="valor" label="descr"
                            :placeholder="volumeStatus.placeholder" tag-placeholder="" select-label=""
                            :options="volumeStatus.options" :clear-on-select="false" :hide-selected="true"
                            :disabled="volumeStatus.disabled">
                        </multiselect>
                    </b-col>
                </b-row>
              <b-row no-gutters>
                <b-col sm="12" md="12" class="d-flex flex-wrap justify-content-end">
                  <b-col cols="12" md="2" class="mb-2 mb-md-0">
                    <b-btn class="secondary w-100" @click="doFilter" :disabled="!hasRequiredFilters()">
                      Filtrar
                    </b-btn>
                  </b-col>

                  <b-col cols="12" md="2">
                    <b-btn class="secondary w-100" @click="onResetFilters" :disabled="vuetableFilterButton">
                      Limpar
                    </b-btn>
                  </b-col>
                </b-col>
              </b-row>
            </div>
        </div>

        <!--Body -->
        <vuetable ref="vuetable" api-url="/api/consulta_pendencia" :fields="fields" :css="css"
            :append-params="filterParams" track-by="docfisvol_id" pagination-path="meta" @vuetable:pagination-data="onPaginationData
                " @vuetable:loaded="onLoaded" @vuetable:onDetail="onDetail" @vuetable:cell-clicked="onDetail"
            detail-row-component="vuetable-row-details" :no-data-template='tableNoData' :row-class="rowClass"
            :load-on-start="false" :class="{ 'table-responsive': deviceSize == DeviceSizeEnum.XS }">

            <template slot="redespacho" slot-scope="props">
                <span v-if="props.rowData.doc_fiscal.doc_fiscal_partes_env.red_nome != null" v-b-tooltip
                    :title="formatCNPJ(props.rowData.doc_fiscal.doc_fiscal_partes_env.red_cnpj)">
                    {{ props.rowData.doc_fiscal.doc_fiscal_partes_env.red_nome }}</span>
            </template>
            <template slot="emissor" slot-scope="props">
                <span v-if="props.rowData.doc_fiscal.doc_fiscal_partes_env.emi_nome != null" v-b-tooltip
                    :title="formatCNPJ(props.rowData.doc_fiscal.doc_fiscal_partes_env.emi_cnpj)">
                    {{ props.rowData.doc_fiscal.doc_fiscal_partes_env.emi_nome }}</span>
            </template>
            <template slot="status" slot-scope="props">
                <!-- 4 Aguardando Travativa -->
                <span class="badge badge-danger" v-if="props.rowData.status.valor == 4">{{ props.rowData.status.descr
                    }}</span>
            </template>
            <template slot="actions" slot-scope="props">
                <div class="custom-actions">
                    <span>
                        <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i
                                class="fa fa-plus"></i></a>
                    </span>
                </div>
            </template>
        </vuetable>
        <div class="col-md-12">
            <div class="pull-left pagination-detail">
                <vuetable-pagination-info ref="paginationInfo" :css="css.pagination"
                    info-class="pull-left"></vuetable-pagination-info>
            </div>
            <div class="pull-right m-a-0">
                <vuetable-pagination ref="pagination" :css="css.pagination" @vuetable-pagination:change-page="onChangePage
                    "></vuetable-pagination>
            </div>
        </div>
        <ResolucaoOcorrenciaModal ref="resolucaoOcorrenciaModal" @refreshTable="refreshTable"></ResolucaoOcorrenciaModal>
    </div>
</template>
<script>
import Vue from "vue";
import AvisoErros from "../components/AvisoErros.vue";
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import { formatCNPJ, formatDateTime, rowClassByDueDate } from "../utils";
import ConsultaPendenciaDetails from "./ConsultaPendenciaDetails.vue";
import moment from "moment";
import ResolucaoOcorrenciaModal from "./ResolucaoOcorrenciaModal.vue";
import Errors from "../Errors";
import Form from "../Form";
import { DeviceSizeEnum } from "../enums/GeneralEnums";

Vue.component("vuetable-row-details", ConsultaPendenciaDetails);
export default {
    components: {
        AvisoErros,
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        ResolucaoOcorrenciaModal
    },
    data() {
        return {
            DeviceSizeEnum,
            invoiceNFeInput: '',
            batchIdInput: '',
            cargoInput: '',
            initialEventDateInput: '',
            finalEventDateInput: '',
            mdfeInput: '',
            redispatchNameInput: '',
            redispatchIdInput: '',
            initialInvoiceDateInput: '',
            finalInvoiceDateInput: '',
            senderNameInput: '',
            senderCnpjInput: '',
            initialEmissionDateInput: '',
            finalEmissionDateInput: '',
            area: {
                input: null,
                options: [],
                disabled: false,
                placeholer: 'Area CD',
            },
            initialForecastDateInput: '',
            finalForecastDateInput: '',
            occurance: {
                input: null,
                options: [],
                placeholder: 'Ocorrencia',
                disabled: false,
            },
            volumeInput: '',
            barcodeInput: '',
            volumeStatus: {
                input: null,
                options: [],
                placeholder: 'Status',
                disabled: false,
            },
            vuetableFilterButton: false,
            loadingData: false,
            showFilters: true,
            errors: new Errors(),
            filterForm: new Form({
                num_fiscal: '',
                lote: '',
                num_carga: '',
                dt_ocorrencia_ini: '',
                dt_ocorrencia_fim: '',
                num_doc_ini: '',
                num_doc_fim: '',
                num_manifesto: '',
                nome_red: '',
                cnpj_red: '',
                dt_emi_doc_ini: '',
                dt_emi_doc_fim: '',
                nome_emi: '',
                cnpj_emi: '',
                dt_emi_ini: '',
                dt_emi_fim: '',
                area: '',
                dt_previsao_ini: '',
                dt_previsao_fim: '',
                ocorrencia: '',
                num_volume: '',
                cd_barra: '',
                status: ''
            }),
            filterParams: {},
            tableData: [],

            tableNoData: "Adicione um filtro para visualizar",

            fields: [
                { name: "doc_fiscal.num_fiscal", title: "Nº NF" },
                { name: "doc_fiscal.serie", title: "Serie" },
                {
                    name: "doc_fiscal.dt_emissao", title: "Data Emissão NF",
                    callback: (row) => { return this.parseDatetime(row) }
                },
                {
                    name: "doc_fiscal.dt_previsao", title: "Data Previsão",
                    callback: (row) => { return this.parseDatetime(row) }
                },
                { name: "num_volume", title: "Volume" },
                {
                    name: "doc_fiscal_volume_ocorrencia", title: "Ocorrencia",
                    callback: (row) => { return row.length > 0 ? row[row.length - 1].descr : 'N/A'; }
                },
                {
                    name: "doc_fiscal_volume_ocorrencia", title: "Data Ocorrência",
                    callback: (row) => { return row.length > 0 ? this.parseDatetime(row[row.length - 1].dt_inc) : 'N/A'; }
                },
                {
                    name: "doc_fiscal.doc", title: "N Controle",
                    callback: (row) => { return row ? row.num_controle : 'N/A'; }
                },
                { name: "__slot:emissor", title: "Emissor NFe" },
                { name: "doc_fiscal.doc_fiscal_partes_env.des_nome", title: "Destinatário" },
                { name: "__slot:redespacho", title: "Redespacho" },
                {
                    name: "doc_fiscal.doc_fiscal_partes_env", title: "Região",
                    callback: (row) => { return row.des_regiao ? row.des_regiao.cd + ' - ' + row.des_regiao.descr : 'N/A'; }
                },
                { name: "doc_fiscal.num_lote", title: "Lote" },
                {
                    name: "doc_fiscal_volume_bip", title: "Pallet",
                    callback: (row) => { return row.length > 0 && row[row.length - 1].pallet_id ? `P${row[row.length - 1].pallet_id}` : 'N/A'; }
                },
                { name: "__slot:status", title: "Status" },
                { name: "__slot:actions", title: "Ações", titleClass: "center aligned", dataClass: "center aligned" },
            ],
            css: {
                tableClass: "table",
                loadingClass: "loading",
                ascendingIcon: "glyphicon glyphicon-chevron-up",
                descendingIcon: "glyphicon glyphicon-chevron-down",
                handleIcon: "glyphicon glyphicon-menu-hamburger",
                detailRowClass: "vuetable-detail-row",
            },
        }
    },
    mounted() {
        this.loadFilterData();
    },
    methods: {
      refreshTable() {
        Vue.nextTick(() => {
          if (this.$refs.vuetable) {
            this.$refs.vuetable.reload();
          }
        });
      },
        onResolveEvent() {
            this.$refs.resolucaoOcorrenciaModal.onCreate();
        },
        rowClass(data) {
            return rowClassByDueDate(
                data.doc_fiscal.dt_previsao,
                this.invoiceDueAlert,
                this.invoiceDueAlertDays);
        },
        onResetFilters() {
            this.filterParams = { 'status': -1 }
            this.invoiceNFeInput = '';
            this.batchIdInput = '';
            this.cargoInput = '';
            this.initialEventDateInput = '';
            this.finalEventDateInput = '';
            this.mdfeInput = '';
            this.redispatchNameInput = '';
            this.redispatchIdInput = '';
            this.initialInvoiceDateInput = '';
            this.finalInvoiceDateInput = '';
            this.senderNameInput = '';
            this.senderCnpjInput = '';
            this.initialEmissionDateInput = '';
            this.finalEmissionDateInput = '';
            this.area.input = null;
            this.initialForecastDateInput = '';
            this.finalForecastDateInput = '';
            this.occurance.input = null;
            this.volumeInput = '';
            this.barcodeInput = '';
            this.volumeStatus.input = null;
            this.tableNoData = "Adicione um filtro para visualizar";
        },

        loadFilterData() {
            this.loadingData = true;
            new Form({})
                .get(`/api/consulta_pendencia/jsonlist`)
                .then((response) => {
                    if (response.area && response.area.length > 0) {
                        this.area.options = response.area.map(area => ({
                            area_id: area.area_id,
                            descr: `A${area.area_id} - ${area.descr}`
                        }));
                    }
                    else {
                        this.area.disabled = true;
                        this.area.placeholder = 'Nenhuma Area Cadastrada';
                    }
                    if (response.ocorrencia && response.ocorrencia.length > 0) {
                        this.occurance.options = response.ocorrencia;
                        this.occurance.options = response.ocorrencia.map(occurance => ({
                            parocorren_id: occurance.parocorren_id5,
                            descr: `${occurance.cd} - ${occurance.descr}`
                        }));
                    }
                    else {
                        this.occurance.disabled = true;
                        this.occurance.placeholder = 'Nenhuma Ocorrencia Cadastrada';
                    }
                    if (response.status && response.status.length > 0) {
                        response.status.forEach(status => {
                            if (status.valor == 4) {
                                this.volumeStatus.options.push(status);
                            }
                        });
                    }
                    else {
                        this.volumeStatus.disabled = true;
                        this.volumeStatus.placeholder = 'Nenhum Status Cadastrado';
                    }
                });

            this.loadingData = false;
        },
        parseDatetime(data) {
            return formatDateTime(data);
        },
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
            this.$refs.paginationInfo.setPaginationData(paginationData);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        onLoaded() {
            this.loadingData = false;
            this.$store.commit("setVuetableFilterButton", false); // quero tirar

        },
        hasRequiredFilters() {
            return [
                this.invoiceNFeInput, this.batchIdInput, this.cargoInput,
                this.initialEventDateInput, this.finalEventDateInput,
                this.mdfeInput, this.redispatchNameInput, this.redispatchIdInput,
                this.initialInvoiceDateInput, this.finalInvoiceDateInput,
                this.senderNameInput, this.senderCnpjInput, this.initialEmissionDateInput,
                this.finalEmissionDateInput, this.area.input, this.initialForecastDateInput,
                this.finalForecastDateInput, this.occurance.input, this.volumeInput,
                this.barcodeInput, this.volumeStatus.input,
            ].some(value =>
                Array.isArray(value) ? value.length > 0 :
                    typeof value === "string" ? value.trim() !== "" :
                        value !== null && value !== undefined
            );
        },

        doFilter() {
            if (!this.hasRequiredFilters()) {
                return this.$Simplert.open({
                    title: "Atenção",
                    message: "Nenhum filtro aplicado",
                    customCloseBtnText: "Fechar",
                    type: "info",

                })
            }

            this.filterParams = {
                'num_fiscal': this.invoiceNFeInput,
                'lote': this.batchIdInput,
                'num_carga': this.cargoInput,
                'dt_ocorrencia_ini': this.formatDateSubmit(this.initialEventDateInput),
                'dt_ocorrencia_fim': this.formatDateSubmit(this.finalEventDateInput),
                'num_manifesto': this.mdfeInput,
                'nome_red': this.redispatchNameInput,
                'cnpj_red': this.redispatchIdInput,
                'dt_emi_doc_ini': this.formatDateSubmit(this.initialInvoiceDateInput),
                'dt_emi_doc_fim': this.formatDateSubmit(this.finalInvoiceDateInput),
                'nome_emi': this.senderNameInput,
                'cnpj_emi': this.senderCnpjInput,
                'dt_emi_ini': this.formatDateSubmit(this.initialEmissionDateInput),
                'dt_emi_fim': this.formatDateSubmit(this.finalEmissionDateInput),
                'area': this.area.input ? this.area.input.area_id : null,
                'dt_previsao_ini': this.formatDateSubmit(this.initialForecastDateInput),
                'dt_previsao_fim': this.formatDateSubmit(this.finalForecastDateInput),
                'ocorrencia': this.occurance.input ? this.occurance.input.parocorren_id : null,
                'num_volume': this.volumeInput,
                'cd_barra': this.barcodeInput,
                'status': this.volumeStatus.input ? this.volumeStatus.input.valor : null,
            };

            Vue.nextTick(() => {
                this.$refs.vuetable.refresh()
            })

        },

        onDetail(data) {
            this.$refs.vuetable.toggleDetailRow(data.docfisvol_id);
        },
        getPermission(checkPermission) {
            return this.getPermissionFw(checkPermission);
        },

        formatCNPJ(data) {
            return formatCNPJ(data);
        },
        formatDateSubmit(value, fmt = "DD/MM/YYYY") {
            return value == null || value == ""
                ? ""
                : moment(value, "YYYY-MM-DD HH:mm").format(fmt);

        },
    },

    watch: {
        filterParams() {
            Vue.nextTick(() => {
                this.$refs.vuetable.refresh()
            });
        },

        palletInput() {
            if (this.palletInput && this.palletInput.length == 0) {
                this.barcodeDisabled = true;
            }
            else {
                this.barcodeDisabled = false;
            }
        }
    },

    computed: {
        isFullscreen: {
            get() {
                return this.$store.getters.is_full_screen;
            },
        },
        invoiceDueAlert() {
            return this.$store.getters.unidade_active.aviso_vencimento;
        },
        invoiceDueAlertDays() {
            return this.$store.getters.unidade_active.dias_vencimento;
        },
        deviceSize() {
            return this.$store.getters.device_size;
        },
    },
};

</script>